module.exports = __webpack_public_path__ + "img/share.5cecd9bd.png";